import type { Measurement, Rollup } from "../../types.ts";
import {
	formatDecimalPercent,
	formatMeasuredOn,
	formatProgressPercent,
} from "../../utils/format.ts";

export function MeasurementCell({
	measurement,
	rollup,
	isLeaf,
	cancelled,
}: {
	measurement: Measurement | undefined;
	rollup: Rollup | undefined;
	isLeaf: boolean;
	cancelled: boolean;
}) {
	if (cancelled) {
		return <span className="measurement-cell is-cancelled">—</span>;
	}
	if (!isLeaf) {
		if (!rollup) {
			return <span className="measurement-cell is-empty">Sem medição</span>;
		}
		return (
			<span className="measurement-cell">
				<span className="measurement-cell__percent">
					{formatDecimalPercent(rollup.percent)}
				</span>
			</span>
		);
	}
	if (!measurement) {
		return <span className="measurement-cell is-empty">Sem medição</span>;
	}
	return (
		<span className="measurement-cell">
			<span className="measurement-cell__percent">
				{formatProgressPercent(measurement.progressPercent)}
			</span>
			<span className="measurement-cell__date">
				{formatMeasuredOn(measurement.measuredOn)}
			</span>
		</span>
	);
}
